import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, LazyLoadImage } from 'ck-ui';
import { getSanityImg } from 'src/sanityClient';
import styles from './FeatureCard.module.scss';

const FeatureCard = ({
  anchorLink,
  centerComponent,
  titleOnly,
  description,
  image,
  textColour,
  titleDesktop,
  backgroundColour,
}) => (
  <div
    role="button"
    tabIndex="0"
    className={styles.container}
    style={{ backgroundColor: backgroundColour }}
    onClick={() => {
      location.hash = `#${anchorLink}`;
    }}
  >
    {!image ? (
      <Icon
        name="ck-logo"
        className={styles.logoIcon}
        style={{ color: textColour }}
      />
    ) : (
      <LazyLoadImage
        src={getSanityImg(image).url()}
        alt="feature nav"
      />
    )}
    <div
      className={classnames(styles.title, { [styles.centerTitle]: centerComponent }, { [styles.marginTop]: titleOnly })}
      style={{ color: textColour }}
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: titleDesktop }}
    />
    { description && (
      <div className={classnames(styles.description, { [styles.centerDescription]: centerComponent }, { [styles.hide]: titleOnly })}>
        {description}
      </div>
    )}
    <a
      href={`#${anchorLink}`}
      className={styles.moreInfoContainer}
    >
      <div
        style={{ color: textColour }}
        className={classnames(styles.moreInfo, { [styles.hide]: titleOnly })}
      >
        MORE INFO
      </div>

      <Icon
        name="triangle-down"
        className={styles.downIcon}
        style={{ color: textColour }}
      />
    </a>
  </div>
);

FeatureCard.propTypes = {
  anchorLink: PropTypes.string.isRequired,
  textColour: PropTypes.string,
  image: PropTypes.object,
  centerComponent: PropTypes.bool,
  description: PropTypes.string,
  titleOnly: PropTypes.bool,
  titleDesktop: PropTypes.string.isRequired,
  backgroundColour: PropTypes.string,
};

FeatureCard.defaultProps = {
  centerComponent: false,
  description: null,
  image: null,
  textColour: '',
  titleOnly: false,
  backgroundColour: ''
};

export { FeatureCard };
